// Human-facing description of the projection model — the single source of truth
// for the factor weights and the crowd-blend threshold. The worker
// (`estimation.ts`) attaches the value-extraction logic to these keys; the
// frontend "How it works" page reads the same numbers so the explainer can
// never drift from the model that actually runs.

/** Crowd reaches full weight in the blended forecast at this many votes. */
export const CROWD_FULL_WEIGHT_AT = 30;

/** The model's factor keys, ordered heaviest-first for display. */
export const FACTOR_KEYS = [
  "careerDamage",
  "incumbent",
  "rulingParty",
  "level",
  "premium",
  "subscribers",
  "military",
  "campaign",
] as const;

export type FactorKey = (typeof FACTOR_KEYS)[number];

/** Each factor's weight. Keep in sync with the value extractors in `estimation.ts`. */
export const FACTOR_WEIGHTS: Record<FactorKey, number> = {
  careerDamage: 18,
  incumbent: 15,
  rulingParty: 12,
  level: 10,
  premium: 8,
  subscribers: 7,
  military: 6,
  campaign: 6,
};
